import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Components } from './components';
import Danke from './Danke';

const { 
  Header, 
  Hero, 
  Services, 
  Gallery,
  Events, 
  About, 
  Contact, 
  Footer,
  PriceGuaranteeBanner
} = Components;

const Home = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Scroll to section function
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} scrollToSection={scrollToSection} />
      <Hero scrollToSection={scrollToSection} />
      <Services />
      <Gallery />
      <Events />
      <About />
      <Contact />
      <Footer />
      <PriceGuaranteeBanner />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/danke" element={<Danke />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;